import { pipe } from "fp-ts/function";
import { fold, isRight } from "fp-ts/Either";
import { makeWordPressAjaxRequest } from "../wordpress/ajax";
import * as t from "io-ts";
import {
  ExportedTree,
  ExportedTreeV,
} from "@/types/tree";
import { iotsErrorsToCustomErrorType } from "@/util/io-ts-errors-to-_error";
import { SECTION_SLUG } from "../elements/constants";
import { SingularitySectionLibrary } from "./library-singleton";
import { getDesignSetBarebonesData } from "@/subapps/onboarding/lib/pages";

export async function getDesignSetSingularityData(): Promise<DesignSetSingularityData | void> {
  const url = "https://breakdancelibrary.com/samba/";

  return pipe(
    await makeWordPressAjaxRequest({
      action: "breakdance_get_design_set_singularity_data_from_remote",
      decoder: DesignSetSingularityDataV,
      friendlyName: "Design Set Singularity Data From Remote",
      dataToPost: { url }
    }),
    fold(
      () => {
        return;
      },
      (data: DesignSetSingularityData) => {
        return data;
      }
    )
  );
}

export const DesignSetSingularityDataV = t.type({
  posts: t.array(
    t.type({
      title: t.string,
      tree: t.unknown
    })
  )
});

export type DesignSetSingularityData = t.TypeOf<
  typeof DesignSetSingularityDataV
>;

export async function getPostsWithValidTreeFromRemote() {
  const designSetSingularityData = await getDesignSetBarebonesData();

  if (!designSetSingularityData) return false;

  const postsWithValidTree = designSetSingularityData.posts.filter(post => {
    return !!post.tree && isRight(ExportedTreeV.decode(post.tree));
  }) as PostWithValidTree[];

  return postsWithValidTree;
}

export function convertPostsWithValidTreeToSingularitySectionLibrary(
  posts: PostWithValidTree[]
): SingularitySectionLibrary {
  const singularitySectionLibrary: SingularitySectionLibrary = {};

  posts.forEach(post => {
    singularitySectionLibrary[post.title] = post.tree.root.children.filter(
      n => {
        return (
          (n.data.type === SECTION_SLUG ||
            n.data.type === "EssentialElements\\HeaderBuilder") &&
          n.children.length > 0
        );
      }
    );
  });

  return singularitySectionLibrary;
}

type PostWithValidTree = { title: string; tree: ExportedTree };
